import React from "react";
import firebase from "../firebase";

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // You can also log the error to an error reporting service
    firebase.analytics().logEvent("component_crashed", {
      error: error ? error.toString() : "",
      errorInfo: errorInfo ? JSON.stringify(errorInfo) : "",
      page: this.props.page,
      section: this.props.section,
      user_source: this.props.userSource,
      mobile: this.props.mobile ? this.props.mobile : "",
    });
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return <></>;
    }

    return this.props.children;
  }
}
